module.exports = __webpack_public_path__ + "7b0694778c0968650d8cc7803f6d8892.png";